import { lazy } from 'react';
import { Route } from 'react-router';

import { FRONTEND_ROUTES } from '@/services/Constants';

const AchievementsPage = lazy(() => import('../components/AchievementsPage') as any);

export function achievementsRoutes() {
	return (
		<>
			<Route path={FRONTEND_ROUTES.FREE_PLAY_ACHIEVEMENTS} element={<AchievementsPage />} />
			<Route
				path={FRONTEND_ROUTES.FREE_PLAY_CATEGORY_ACHIEVEMENTS}
				element={<AchievementsPage />}
			/>
		</>
	);
}
